window.$ = window.jQuery = require('jquery');
import uploadcare from 'uploadcare-widget';
/**
 * @class
 */
export default class UploadcareMultiple {
    /**
     * Initialize Header
     * @function
     */
    constructor(el) {
        this.el = el;
        this.pubKey = UPLOADCARE_PUBLIC_KEY;
        this.privateKey = atob(prodent_ucs).replace(/\#/g,'');
        
        if (!this.el.length) {
            return;
        }

        this.uploadcareMlt = uploadcare;
        this.installWidgetPreviewMultiple(
            this.uploadcareMlt.MultipleWidget(this.el.children('input')),
            this.el.children('.uploaded_list')
            );
        
//        this.installWidgetPreviewSingle(
//            this.uploadcareMlt.SingleWidget(this.el.children('input')),
//            this.el.children('.uploaded_list')
//        );
    }

    createNewGroup(GroupArr, input) {
        var _this = this;
        if (!GroupArr.length) {
            $(input).closest('.image-preview-multiple').find('.upl-area').removeClass('disabled');
            _this.uploadcareMlt.MultipleWidget(input).value('');
            return
        }
//        if (!GroupArr.length) {
//            $(input).closest('.image-preview-multiple').find('.upl-area').removeClass('disabled');
//            _this.uploadcareMlt.SingleWidget(input).value('');
//            return
//        }
         $("#ajax-loader").fadeIn();
        $.ajax({
            url: "https://upload.uploadcare.com/group/",
            data: {
                pub_key: _this.pubKey,
                files: GroupArr,
            },
            headers: {
                "Accept": "application/vnd.uploadcare-v0.5+json",
            },
            success: function (result) {
                $("#ajax-loader").fadeOut();
                console.log(result.id);

                _this.uploadcareMlt.MultipleWidget(input).value(result.id);
//                _this.uploadcareMlt.SingleWidget(input).value(result.id);
//                console.log(result.id);
            },
            error: function (result) {
                $("#ajax-loader").fadeOut();
                console.log(result);
            }
        });
    }

    deleteFileUploadCare(uuid) {
        var _this = this;
        $("#ajax-loader").fadeIn();
        $.ajax({
            url: "https://api.uploadcare.com/files/" + uuid + "/",
            type: "DELETE",
            headers: {
                "Accept": "application/vnd.uploadcare-v0.5+json",
                "Authorization": "Uploadcare.Simple " + _this.pubKey + ":" + _this.privateKey
            },
            success: function (result) {
                $("#ajax-loader").fadeOut();
                console.log(result);
            },
            error: function (result) {
                $("#ajax-loader").fadeOut();
                console.log(result);
            }
        });
    }

    installWidgetPreviewMultiple(widget, list) {
        var _this = this;
        widget.onChange(function (fileGroup) {
            list.empty();
            $("#ajax-loader").fadeIn();
            if (fileGroup) {

                $.when.apply(null, fileGroup.files()).done(function () {
                    $.each(arguments, function (i, fileInfo) {
                        var src;
                        if (fileInfo.isImage) {
                            src = fileInfo.cdnUrl + '-/scale_crop/160x160/center/';
                        } else {
                            src = '../../images/pdf-thumb.png';
                            
                            if($('#digitalOrderPrint').html()) {
                                src = '../../../images/pdf-thumb.png';
                            }
                        }
                        if($('#order-step5').html() || $('#digitalOrderPrint').html()) {
                            list.append(
                                $('<div/>', {'class': 'clearfix _item uploaded-item'}).append([$('<img   />', {src: src, class: 'uploaded-img group-img', uuid: fileInfo.uuid}), '<span class="vam file-name">' + fileInfo.name + '</span>', ''])
                            );
                        }
                        else {    
                            list.append(
                                $('<div/>', {'class': 'clearfix _item uploaded-item'}).append([$('<img   />', {src: src, class: 'uploaded-img group-img dialog-open', uuid: fileInfo.uuid}), '<span class="vam file-name dialog-open">' + fileInfo.name + '</span>', '<button type="button" class="remove-item"><span aria-hidden="true">×</span></button>'])
                            );
                        }    
                    });
                    setTimeout(function () {
                        $('.dialog-open').on('click', function () {
                            $('.image-preview-multiple').find('.uploadcare--link').trigger('click');
                            // 	uploadcare.openDialog('9a1dbf3a-d7be-4170-b7d4-efa399b094ab', {
                            //   publicKey: 'adfdd7c72ae330feb7dd',
                            // });
                        });
                        $('._item').find('.remove-item').on('click', function () {
                            let uuidGroupArray = [];
                            let uuid;
                            let uploadedImages;
                            let $uploadedItem = $(this).closest('.uploaded-item');

                            $uploadedItem.find('.uploaded-img').removeClass('group-img');
                            uuid = $uploadedItem.find('.uploaded-img').attr('uuid');
                            uploadedImages = $('.uploaded_list').find('.group-img');

                            uploadedImages.each(function (index) {
                                uuidGroupArray.push($(this).attr('uuid'));
                            });

                            _this.createNewGroup(uuidGroupArray, $uploadedItem.closest('.multiple-files-area-preview').find('[role=uploadcare-uploader]'));
                            $uploadedItem.remove();
                            _this.deleteFileUploadCare(uuid);
                        });
                    }, 0);
                    $("#ajax-loader").fadeOut();
                }).fail(function(error, fileInfo) {
                    $("#ajax-loader").fadeOut();
                    alert("Upload failed, or something else went wrong");
                });
            }
        });
    }

    installWidgetPreviewSingle(widget, list) {
        var _this = this;

        widget.onChange(function (fileGroup) {
            list.empty();
            if (fileGroup) {
                fileGroup.done(function () {
                    $.each(arguments, function (i, fileInfo) {
                        var src;
                        $("input[name=upload_data]").val(fileInfo.cdnUrl);
                        if (fileInfo.isImage) {
                            src = fileInfo.cdnUrl + '-/scale_crop/160x160/center/';
                        } else {
                            src = '../../images/pdf-thumb.png';
                        }
                        list.append(
                            $('<div/>', {'class': 'clearfix _item uploaded-item'}).append([$('<img   />', {src: src, class: 'uploaded-img group-img dialog-open', uuid: fileInfo.uuid}), '<span class="vam file-name dialog-open">' + fileInfo.name + '</span>', '<button type="button" class="remove-item"><span aria-hidden="true">×</span></button>'])
                            );
                    });
                    setTimeout(function () {
                        $('.dialog-open').on('click', function () {
                            $('.image-preview-multiple').find('.uploadcare--link').trigger('click');
                            // 	uploadcare.openDialog('9a1dbf3a-d7be-4170-b7d4-efa399b094ab', {
                            //   publicKey: 'adfdd7c72ae330feb7dd',
                            // });
                        });
                        $('._item').find('.remove-item').on('click', function () {
                            let uuidGroupArray = [];
                            let uuid;
                            let uploadedImages;
                            let $uploadedItem = $(this).closest('.uploaded-item');

                            $uploadedItem.find('.uploaded-img').removeClass('group-img');
                            uuid = $uploadedItem.find('.uploaded-img').attr('uuid');
                            uploadedImages = $('.uploaded_list').find('.group-img');

                            uploadedImages.each(function (index) {
                                uuidGroupArray.push($(this).attr('uuid'));
                            });

                            _this.createNewGroup(uuidGroupArray, $uploadedItem.closest('.multiple-files-area-preview').find('[role=uploadcare-uploader]'));
                            $uploadedItem.remove();
                            _this.deleteFileUploadCare(uuid);
                        });
                    }, 0);
                });

            }
        });
    }

}
